module.exports = __webpack_public_path__ + "static/shareFanWater2BG-16285f522d6b4d6e11f33f38134f3156.png";